export default __webpack_public_path__ + "static/Cam-39c740e399464659692e2b9361e21103.jpg";